// INTAKE COORDINATES
export const GET_INTAKE_COORDINATES_LIST = '/intake_coordinates/query';
export const GET_INTAKE_COORDINATES = '/intake_coordinates/';
export const POST_INTAKE_COORDINATES = '/intake_coordinates/';
export const PUT_INTAKE_COORDINATES = '/intake_coordinates/';
export const DELETE_INTAKE_COORDINATES = '/intake_coordinates/';
